var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mobile-box" },
    [
      _c("van-nav-bar", { attrs: { title: "祺信信息" } }),
      _vm._v(" "),
      _c(
        "van-cell-group",
        { staticClass: "top", attrs: { inset: "" } },
        [
          _c("van-cell", {
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function() {
                  return [
                    _c(
                      "span",
                      { staticClass: "title", staticStyle: { float: "left" } },
                      [_vm._v("祺信编号")]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "title", staticStyle: { float: "right" } },
                      [_vm._v(_vm._s(_vm.gldInfo.gldId))]
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
          _vm._v(" "),
          _c("van-cell", {
            scopedSlots: _vm._u([
              {
                key: "title",
                fn: function() {
                  return [
                    _c("span", { staticClass: "title" }, [
                      _vm._v("祺信金额："),
                      _c("span", { staticStyle: { color: "red" } }, [
                        _vm._v(_vm._s(_vm._f("splitK")(_vm.gldInfo.gldAmt)))
                      ]),
                      _vm._v(" 元")
                    ])
                  ]
                },
                proxy: true
              },
              {
                key: "label",
                fn: function() {
                  return [
                    _vm.type == "voucher"
                      ? [
                          _c("div", { staticClass: "title-time" }, [
                            _c("span", { staticStyle: { float: "left" } }, [
                              _vm._v("开立日：" + _vm._s(_vm.gldInfo.openTime))
                            ]),
                            _vm._v(" "),
                            _c("span", { staticStyle: { float: "right" } }, [
                              _vm._v("到期日：" + _vm._s(_vm.gldInfo.exDayStr))
                            ])
                          ])
                        ]
                      : [
                          _c("div", { staticClass: "title-time" }, [
                            _c("span", { staticStyle: { float: "left" } }, [
                              _vm._v(
                                "支付日：" + _vm._s(_vm.gldInfo.wanderAboutTime)
                              )
                            ]),
                            _vm._v(" "),
                            _c("span", { staticStyle: { float: "right" } }, [
                              _vm._v("到期日：" + _vm._s(_vm.gldInfo.exDayStr))
                            ])
                          ])
                        ]
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "info" },
        [
          _vm.type == "voucher"
            ? [
                _c(
                  "van-cell-group",
                  { attrs: { inset: "" } },
                  [
                    _c("van-cell", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("p", [_vm._v("开立方企业名称")]),
                                _vm._v(" "),
                                _c("p", [_vm._v("开立方信用代码")])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.gldInfo.estb &&
                                        _vm.gldInfo.estb.customerName
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.gldInfo.estb &&
                                        _vm.gldInfo.estb.orgCode
                                    )
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        223695931
                      )
                    }),
                    _vm._v(" "),
                    _c("van-cell", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("p", [_vm._v("担保方企业名称")]),
                                _vm._v(" "),
                                _c("p", [_vm._v("担保方信用代码")])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      (_vm.gldInfo.guar &&
                                        _vm.gldInfo.guar.guarantorName) ||
                                        "-"
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      (_vm.gldInfo.guar &&
                                        _vm.gldInfo.guar.guarantorOrgCode) ||
                                        "-"
                                    )
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        3274357311
                      )
                    }),
                    _vm._v(" "),
                    _c("van-cell", {
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function() {
                              return [
                                _c("p", [_vm._v("接收方企业名称")]),
                                _vm._v(" "),
                                _c("p", [_vm._v("接收方信用代码")])
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.gldInfo.rcPty &&
                                        _vm.gldInfo.rcPty.customerName
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.gldInfo.rcPty &&
                                        _vm.gldInfo.rcPty.orgCode
                                    )
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        1713733691
                      )
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "van-cell-group",
                  { attrs: { inset: "" } },
                  [
                    _c("van-cell", {
                      attrs: {
                        title: "交易资料",
                        "is-link": "",
                        to:
                          "/mobile/dataType/" +
                          this.gldId +
                          "?tenantIds=" +
                          this.tenantIds
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "van-cell-group",
                  { attrs: { inset: "" } },
                  [
                    _c("van-cell", {
                      attrs: { title: "是否可变更到期日" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("GbCbmTrans")(
                                        _vm.gldInfo.canBeModified
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        false,
                        429312596
                      )
                    })
                  ],
                  1
                )
              ]
            : [
                _c(
                  "van-cell-group",
                  { attrs: { inset: "" } },
                  [
                    _c("van-cell", {
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function() {
                            return [
                              _c("p", [_vm._v("兑付方企业名称")]),
                              _vm._v(" "),
                              _c("p", [_vm._v("兑付方信用代码")])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.gldInfo.estb &&
                                      _vm.gldInfo.estb.customerName
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.gldInfo.estb && _vm.gldInfo.estb.orgCode
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("van-cell", {
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function() {
                            return [
                              _c("p", [_vm._v("流转方企业名称")]),
                              _vm._v(" "),
                              _c("p", [_vm._v("流转方信用代码")])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.gldInfo.pypt &&
                                      _vm.gldInfo.pypt.customerName
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.gldInfo.pypt && _vm.gldInfo.pypt.orgCode
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("van-cell", {
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function() {
                            return [
                              _c("p", [_vm._v("接收方企业名称")]),
                              _vm._v(" "),
                              _c("p", [_vm._v("接收方信用代码")])
                            ]
                          },
                          proxy: true
                        },
                        {
                          key: "default",
                          fn: function() {
                            return [
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.gldInfo.rcPty &&
                                      _vm.gldInfo.rcPty.customerName
                                  )
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    _vm.gldInfo.rcPty &&
                                      _vm.gldInfo.rcPty.orgCode
                                  )
                                )
                              ])
                            ]
                          },
                          proxy: true
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "van-cell-group",
                  { attrs: { inset: "" } },
                  [
                    _c("van-cell", [
                      _c(
                        "span",
                        {
                          staticClass: "van-cell__title",
                          staticStyle: { float: "left" }
                        },
                        [_vm._v("母祺信编号")]
                      ),
                      _vm._v(" "),
                      _c(
                        "span",
                        {
                          staticClass: "van-cell__value",
                          staticStyle: { float: "right" }
                        },
                        [_vm._v(_vm._s(_vm.gldInfo.originalId))]
                      )
                    ])
                  ],
                  1
                )
              ]
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-87656c72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-87656c72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/mobile/QXDetails.vue
// module id = aLjb
// module chunks = 1